import * as classNames from "classnames";
import * as React from "react";
import { useForm } from "react-final-form";
import { Button } from "@ui/Button";
import * as s from "./ConcertRows.sss";
import { extractUniqueColorsAndPrices } from "@/utils/common";
const isMobile = window.innerWidth < 768;
function marginPlaces(rowsNumber, rowPlaces) {
    switch (true) {
        case Number(rowsNumber) <= 13:
            return ["15", "7"].filter(name => name === rowPlaces).length
                ? "20px"
                : "";
        case Number(rowsNumber) === 14:
            return ["18", "12", "10", "4"].filter(name => name === rowPlaces).length
                ? "12px"
                : rowPlaces === "11"
                    ? "21px"
                    : "";
        case Number(rowsNumber) === 15:
            return rowPlaces === "12" ? "21px" : "";
        case Number(rowsNumber) === 17:
            return rowPlaces === "7" ? "20px" : "";
        case Number(rowsNumber) === 16:
            return ["8"].filter(name => name === rowPlaces).length ? "20px" : "";
        case rowsNumber === "2Б":
            return ["20", "6"].filter(name => name === rowPlaces).length
                ? isMobile
                    ? "20px"
                    : "40px"
                : "";
        case rowsNumber === "3Б":
            return ["19", "6"].filter(name => name === rowPlaces).length
                ? isMobile
                    ? "20px"
                    : "40px"
                : "";
        default:
            return "";
    }
}
export const ConcertRows = ({ data, refetch, concertId, }) => {
    const { change } = useForm();
    const [selectedIds, setSelectedIds] = React.useState([]);
    const limitTicket = 10;
    const onPlaceIdChange = (place) => {
        setSelectedIds(placeIds => {
            const isSelected = placeIds.includes(place.id);
            if (isSelected) {
                change(`users[${place.id}].rowsName`, undefined);
                change(`users[${place.id}].seat`, undefined);
                change(`users[${place.id}].price`, undefined);
                return placeIds.filter(id => id !== place.id);
            }
            change(`users[${place.id}].rowsName`, place.rowsName);
            change(`users[${place.id}].seat`, place.name);
            change(`users[${place.id}].price`, place.price);
            return [...placeIds, place.id];
        });
    };
    React.useEffect(() => {
        change("placeIds", selectedIds);
        refetch();
    }, [selectedIds]);
    React.useEffect(() => {
        refetch();
    }, [concertId]);
    const pricesInfo = extractUniqueColorsAndPrices(data);
    return (React.createElement("div", { className: s.root },
        React.createElement("div", { className: s.pricesInfo },
            pricesInfo.map(prices => (React.createElement("div", { className: s.pricesColorBlock },
                React.createElement("div", { className: s.pricesColor, style: { backgroundColor: prices.color } }),
                React.createElement("div", null,
                    prices.price,
                    " \u0433\u0440\u043D")))),
            React.createElement("div", { className: s.pricesColorBlock },
                React.createElement("div", { className: s.pricesColor, style: { backgroundColor: "#C6C6C6" } }),
                React.createElement("div", null, "\u041D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E")),
            React.createElement("div", { className: s.pricesColorBlock },
                React.createElement("div", { className: s.pricesColor, style: { backgroundColor: "#23f70f" } }),
                React.createElement("div", null, "\u041E\u0431\u0440\u0430\u043D\u043E"))),
        data.concertRows
            .sort((a, b) => a.id - b.id)
            .map(rows => {
            const rowPlacesCopy = [...rows.rowPlaces];
            const rowPlacesFilter = rowPlacesCopy === null || rowPlacesCopy === void 0 ? void 0 : rowPlacesCopy.sort((a, b) => Number(a.name) - Number(b.name));
            return (React.createElement(React.Fragment, null,
                rows.name === "17" && React.createElement("div", { className: s.nameRow }, "\u0411\u0430\u043B\u043A\u043E\u043D"),
                React.createElement("div", { key: rows.id, className: s.rows, style: {
                        marginBottom: rows.name === "14" ? "40px" : "",
                    } },
                    React.createElement("div", { className: s.name }, rows.name),
                    React.createElement("div", { className: s.rowPlaces }, rowPlacesFilter.map(rowPlaces => (React.createElement(React.Fragment, null,
                        React.createElement(Button, { key: rowPlaces.id, className: classNames(s.rowButton, {
                                [s.selected]: selectedIds.includes(rowPlaces.id),
                            }), style: {
                                backgroundColor: !selectedIds.includes(rowPlaces.id) &&
                                    rowPlaces.isAvailable &&
                                    rowPlaces.color,
                                marginLeft: marginPlaces(rows.name, rowPlaces.name),
                            }, disabled: (selectedIds.length > limitTicket &&
                                !selectedIds.filter(ids => ids === rowPlaces.id)
                                    .length) ||
                                !rowPlaces.isAvailable, onClick: () => onPlaceIdChange(Object.assign(Object.assign({}, rowPlaces), { rowsName: rows.name })) }, rowPlaces.name),
                        (rows.name === "16" && rowPlaces.name === "7") ||
                            (rows.name === "17" && rowPlaces.name === "6") ? (React.createElement("div", { className: s.emptyBlock })) : null)))),
                    React.createElement("div", { className: s.name }, rows.name))));
        })));
};
